import React from "react";
import { motion } from "framer-motion";

import {
  Typography,
  Box,
  Container,
  Grid,
  Card,
  Chip
} from "@mui/material/";
import StorageIcon from '@mui/icons-material/Storage';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import BuildIcon from '@mui/icons-material/Build';

const skillCategories = [
  {
    title: "Frontend",
    icon: <DeveloperModeIcon />,
    skills: ["React.js", "TypeScript", "JavaScript", "HTML5", "CSS3", "Tailwind CSS"],
  },
  {
    title: "Backend",
    icon: <StorageIcon />,
    skills: ["Node.js", "Express", "PHP", "Java", "MySQL", "Firebase"],
  },
  {
    title: "Mobile",
    icon: <SmartphoneIcon />,
    skills: ["Flutter", "Dart", "Arduino", "C++"],
  },
  {
    title: "Tools",
    icon: <BuildIcon />,
    skills: ["Git", "GitHub", "Vite", "Framer Motion", "REST APIs"],
  }
];

export default function Skills() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <Box
      id="skills"
      sx={{
        py: { xs: 8, md: 12 },
        position: "relative"
      }}
    >
      <Container maxWidth="lg">
        <Box mb={6}>
          <Typography variant="h2" sx={{ color: "text.primary" }}>
            Tech Stack
          </Typography>
        </Box>

        <Box
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <Grid container spacing={3}>
            {skillCategories.map((category, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <motion.div variants={itemVariants} style={{ height: "100%" }}>
                  <Card 
                    sx={{ 
                      p: 3, 
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                      <Box 
                        aria-hidden="true"
                        sx={(theme) => ({ 
                          p: 1, 
                          borderRadius: "8px", 
                          bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
                          color: "primary.main",
                          display: "flex"
                        })}
                      >
                        {category.icon}
                      </Box>
                      <Typography variant="h5" sx={{ color: "text.primary" }}>
                        {category.title}
                      </Typography>
                    </Box>
                    
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {category.skills.map((skill, skillIndex) => (
                        <Chip 
                          key={skillIndex} 
                          label={skill} 
                        />
                      ))}
                    </Box>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}
